export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher100_tab_roi@2x.154f3eb7.png";